export default {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    backgroundColor: 'transparent',
    spacing: [0, 0, 0, 0],
  },
  title: {
    text: '',
  },
  tooltip: {
    enabled: true,
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
  },
  plotOptions: {
    pie: {
      size: '100%',
      innerSize: '80%',
      dataLabels: {
        enabled: false,
      },
      point: {
        events: {},
      },
    },
    series: {
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
  series: [
    {
      type: 'pie',
      name: 'Asset Allocation',
      data: [],
    },
  ],
  credits: {
    enabled: false,
  },
};
